import { render, staticRenderFns } from "./SaleStatisticType.vue?vue&type=template&id=6da1efbf"
import script from "./SaleStatisticType.vue?vue&type=script&lang=js"
export * from "./SaleStatisticType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports